export function getCapacitorRuntimeInfo() {
  if (typeof window === 'undefined') {
    return { hasCapacitor: false, isNative: false, platform: '' };
  }
  const cap = window.Capacitor;
  if (!cap) {
    return { hasCapacitor: false, isNative: false, platform: '' };
  }
  let platform = '';
  try {
    if (typeof cap.getPlatform === 'function') {
      platform = String(cap.getPlatform() || '').trim().toLowerCase();
    }
  } catch (_) {}
  let isNative = false;
  try {
    if (typeof cap.isNativePlatform === 'function') {
      isNative = !!cap.isNativePlatform();
    } else if (platform) {
      isNative = platform !== 'web';
    }
  } catch (_) {
    isNative = platform ? platform !== 'web' : false;
  }
  return {
    hasCapacitor: true,
    isNative,
    platform,
  };
}

export function isNativeRuntime({ honorForceWeb = true } = {}) {
  const forceWeb = honorForceWeb && String(process.env.REACT_APP_FORCE_WEB || '').trim() === '1';
  if (forceWeb) return false;
  return getCapacitorRuntimeInfo().isNative;
}

